import {keepPreviousData, queryOptions} from '@tanstack/react-query';

import {keys} from '@queries/keys';

import {getJobRuns, type GetJobRunsRequest} from './getJobRuns';

export const jobRunsQueryOptions = (req: GetJobRunsRequest) =>
  queryOptions({
    queryKey: keys.system.runs(req),
    queryFn: () => getJobRuns(req),
    placeholderData: keepPreviousData,
  });
